import { getCmsDestinations } from "../../../app/api/getCmsDestinations";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, IBookedOffer } from "../../../Orchestrator/Types/Index";
import { ICmsDestination, ICmsDestinationResponse } from "../../../Orchestrator/Types/Interface/ICmsDestination";


class GetCmsDestinationsAction extends BaseAction<ICmsDestination[], void> {
  override async run(): Promise<ICmsDestination[] | null> {
    let listOfDestinations: ICmsDestination[] = [];
    try {
      const response: IApiResponse<ICmsDestinationResponse> = await getCmsDestinations();

      if (response.status === "ok" && response.answer) {
        const destinations = response.answer.data;
        if (destinations.length > 0) {
          listOfDestinations = destinations
          updateRecoilState("destinationResponseAtom", listOfDestinations);
        } else {
          console.warn("No destinations available.");
        }
      } else {
        console.warn("Failed to fetch destinations.");
      }
    } catch (error: any) {
      console.error("Error fetching destinations:", error);
    } finally {
      updateRecoilState("popularDestinationsLoadedAtom", true);
      return listOfDestinations;
    }
  }
}

export const getCmsDestinationsAction = new GetCmsDestinationsAction()